import styled from 'styled-components';
import breakpoints from 'constants/breakpoints';

export const NavItem = styled.div<{ layer?: 'second' | 'third'; hideOnMobile?: boolean }>`
  display: flex;

  @media (max-width: ${breakpoints.size.md}px) {
    display: ${(props) => (props.hideOnMobile === true ? 'none' : 'block')};
  }

  text-align: left;
  border: 0;
  width: 100%;
  border-bottom: ${(props) =>
    props.layer === 'second' ? `1px solid ${props.theme.colors.lightGrey3} ` : 'none'};
  margin-top: ${(props) => (props.layer === 'second' ? '16px' : '18px')};
  a {
    display: block;
    line-height: inherit;
    text-align: center;
    padding: ${(props) => (props.layer === 'second' ? '16px 8px' : '8px 16px')};
  }
  ul {
    list-style: none;
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    li {
      .nav-menu__tab {
        font-size: clamp(12px, 1.5vw, 14px);
      }
    }
  }
  & > div:last-child {
    margin-left: auto;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: start;
  font-size: 0.8125rem;
  .nav__menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    border-radius: 0;
    &.hidden {
      display: none;
    }
  }
  .icon {
    padding-left: 1rem;
  }
`;

export const Tab = styled.a<{
  $isSelected?: boolean;
  layer?: 'second' | 'third';
  isTabEnabled?: boolean;
}>`
  all: unset;
  display: flex;
  font-size: 0.885rem;
  font-weight: ${(props) => (props.$isSelected ? '600' : '400')};
  color: ${(props) =>
    props.isTabEnabled === false
      ? props.theme.colors.tableborder
      : props.$isSelected
      ? props.theme.colors.primaryBlue5
      : props.theme.colors.lightGrey8};
  cursor: ${(props) => (props.isTabEnabled === false ? 'not-allowed' : 'pointer')};
  padding-bottom: 0;

  ${(props) =>
    props.layer === 'second' &&
    `
    border: none;
    border-bottom: ${props.$isSelected ? `2px solid ${props.theme.colors.primaryBlue5}` : 'none'};
    background-color: transparent;

    &:hover {
     ${
       props.isTabEnabled === true || props.isTabEnabled === undefined
         ? `
            color: ${props.theme.colors.primaryBlue5};
          `
         : ''
     }
  `}

  ${(props) =>
    props.layer === 'third' &&
    `
    border: ${
      props.isTabEnabled === false
        ? `1px solid ${props.theme.colors.lightGrey3}`
        : props.$isSelected
        ? `1px solid ${props.theme.colors.primaryBlue5}`
        : `1px solid ${props.theme.colors.mediumGrey2}`
    };
    border-radius: 50px;
    padding: 8px 16px;
    background-color: ${
      props.isTabEnabled === false
        ? props.theme.colors.lightGrey1
        : props.$isSelected
        ? props.theme.colors.info300
        : 'transparent'
    };

    &:hover {
      ${
        props.isTabEnabled === true || props.isTabEnabled === undefined
          ? `
        color: ${props.theme.colors.primaryBlue5};
        border: 1px solid ${props.theme.colors.primaryBlue5};
        background-color: ${props.theme.colors.info300};
      `
          : ''
      }
    }
  `}
`;
